import { t } from '@/utils/i18n'
import { useState } from 'react'
import styles from './CorpIntro.module.less'
import { ImageViewer } from 'antd-mobile'
import useCorpInfoStore from '@/stores/corp-info'
import { useNavigate } from 'react-router-dom'
import { routesMap } from '@/utils'
import defaultAvatar from '@/assets/img/default/corp_avatar.png'
import iconPhone from '@/assets/img/icon/phone.png'
import iconAddress from '@/assets/img/icon/address.png'
import iconNotice from '@/assets/img/icon/notice.png'
import localStorage from "@/utils/localStorage";

const { getLocalStorage } = localStorage

function CorpIntro() {
  const navigate = useNavigate()
  const { corpInfo } = useCorpInfoStore()
  const ossRoot = getLocalStorage('ossRoot')
  const {
    corpLogo,
    corpName,
    cloudStoreContactPhone,
    cloudStoreContactPerson,
    address,
    cloudStoreNotice,
    corpIntroWord,
    corpAlbumList,
  } = corpInfo
  const [visible, setVisible] = useState(false)
  const logo = corpLogo ? ossRoot + corpLogo : defaultAvatar
  function handleEnterStore() {
    navigate(routesMap.App)
  }

  function handlePreviewImg() {}

  const ImgItem = () => {
    return (corpAlbumList || []).map((item: string, index: number) => {
      return (
        <img
          key={index}
          src={item}
          className={styles['album-img']}
          onClick={handlePreviewImg}
        />
      )
    })
  }

  return (
    <div className={styles['corp-intro']}>
      <div className={styles['header-intro']}>
        <div className={styles['mask']} />
        <div className={styles['bg-cover']}>
          <img src={logo} className={styles['bg-cover-img']} />
        </div>

        <div className={styles['avatar-corpname-section']}>
          <img className={styles['avatar']} src={logo} />

          <div className={styles['corpname']}>{corpName}</div>
        </div>
        {cloudStoreContactPhone ? (
          <a
            className={styles['phone-section']}
            href={`tel:${cloudStoreContactPhone}`}
          >
            <img className={styles['icon']} src={iconPhone} />

            <span className={styles['content-text']}>
              {cloudStoreContactPhone} ({cloudStoreContactPerson})
            </span>
          </a>
        ) : (
          ''
        )}

        {address ? (
          <div className={styles['address-section']}>
            <img className={styles['icon']} src={iconAddress} />

            <span className={styles['content-text']}>{address}</span>
          </div>
        ) : (
          ''
        )}

        {cloudStoreNotice ? (
          <div className={styles['notice-section']}>
            <img className={styles['icon']} src={iconNotice} />

            <span className={styles['content-text']}>{cloudStoreNotice}</span>
          </div>
        ) : (
          ''
        )}

        {/* 进入店铺 */}
        <button className={styles['share-btn']} onClick={handleEnterStore}>
          {t('进入店铺')}
        </button>
      </div>

      {/* 企业图片 */}
      {corpAlbumList && corpAlbumList.length > 0 ? (
        <div className={styles['album-section']}>
          <div className={styles['subtitle']}>{t('企业图片')}</div>
          <div className={styles['intro-img-list']}>
            <ImgItem />
          </div>
          <ImageViewer
            image={corpAlbumList || []}
            visible={visible}
            onClose={() => {
              setVisible(false)
            }}
          />
        </div>
      ) : (
        ''
      )}

      {/* 企业介绍 */}
      {corpIntroWord ? (
        <div className={styles['corp-intro-section']}>
          <div className={styles['subtitle']}>{t('企业介绍')}</div>
          <div className={styles['intro-content']}>{corpIntroWord}</div>
        </div>
      ) : (
        ''
      )}
    </div>
  )
}

export default CorpIntro
